import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { IProduceBackupManager } from '@src/slide/application/service/produce-backup-manager/core/produce-backup-manager.interface';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';

export interface IInactivityGuide {
    setServicesDelegate(services: IInactivityGuideServices): void;
}

export const BUTTON_ACTION_TYPE = {
    CLONE: 'clone', // 生成副本
    TO_PDF: 'toPdf', // 转pdf
    COLLECT: 'collect', // 收藏
    DOWNLOAD: 'download', // 下载，有渠道限制，仅QQ/微信的移动端小程序提示下载
};

export interface IInactivityGuideServices {
    produceBackupManager: IDynamicService<IProduceBackupManager>;
    menuManager?: IMenuManager;
}
